import type { OptionsDocument, QuoteArea } from 'paintscout'
import type { UpdateableAreaSubstrate } from '../../../../index'
import { getObjectLabels } from '../../../../../util'

// Get dimensions for the UpdateableAreaSubstrate to be displayed to crew
export default function getDimensions({
  rateType,
  areaType,
  item,
  area,
  options
}: {
  rateType: string
  areaType: string
  item: UpdateableAreaSubstrate
  options: OptionsDocument
  area: QuoteArea
}) {
  let label = ''
  let value = 0
  const { unit } = getObjectLabels({ options })
  if (rateType === 'quantity') {
    value = Number(item.quantity)
  } else {
    if (areaType === 'surface') {
      const length = item.length?.useCustom ? item.length.custom : item.length?.default
      const height = item.height?.useCustom ? item.height.custom : item.height?.default
      const customSubstrateDimensions = item.length?.useCustom || item.height?.useCustom

      const areaLnft = area.dimensions.override_lnft ? area.dimensions.lnft : area.dimensions.calculated_lnft
      const areaSqft = area.dimensions.override_sqft ? area.dimensions.sqft : area.dimensions.calculated_sqft

      const lnft = customSubstrateDimensions ? length : areaLnft
      const sqft = customSubstrateDimensions ? length * height : areaSqft

      if (rateType === 'lnft') {
        label = unit.abbreviation.linear
        const dimension = lnft
        value = typeof dimension === 'number' ? dimension : parseFloat(dimension)
      } else {
        label = unit.abbreviation.square
        const dimension = sqft
        value = typeof dimension === 'number' ? dimension : parseFloat(dimension)
      }
    } else {
      if (rateType === 'lnft') {
        const dimension = area.dimensions.override_lnft ? area.dimensions.lnft : area.dimensions.calculated_lnft
        value = typeof dimension === 'number' ? dimension : parseFloat(dimension)
        label = unit.abbreviation.linear
      } else if (['sqft_walls', 'sqftWalls'].includes(rateType)) {
        const dimension = area.dimensions.override_sqft_walls
          ? area.dimensions.sqft_walls
          : area.dimensions.calculated_sqft_walls
        value = typeof dimension === 'number' ? dimension : parseFloat(dimension)

        label = unit.abbreviation.square
      } else if (['sqft_ceiling', 'sqftCeiling'].includes(rateType)) {
        label = unit.abbreviation.square

        const dimension = area.dimensions.override_sqft_ceiling
          ? area.dimensions.sqft_ceiling
          : area.dimensions.calculated_sqft_ceiling
        value = typeof dimension === 'number' ? dimension : parseFloat(dimension)
      } else if (['sqft_floor', 'sqftFloor'].includes(rateType)) {
        const dimension = area.dimensions.override_sqft_floor
          ? area.dimensions.sqft_floor
          : area.dimensions.calculated_sqft_floor
        value = typeof dimension === 'number' ? dimension : parseFloat(dimension)
        label = unit.abbreviation.square
      }
    }
  }

  // This is an area substrate, so we'll prioritize the custom dimensions made at the substrate level
  if (item.dimensionOverride?.useCustom && item.dimensionOverride.custom) {
    value = item.dimensionOverride.custom
  }
  return { label, value }
}
